/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Group_Knowledge_DocumentsInputs */



/**
* | output |
* | --- |
* | "Knowledge & documents" |
*
* @param {Onboarding_Usage_Group_Knowledge_DocumentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_group_knowledge_documents = /** @type {((inputs?: Onboarding_Usage_Group_Knowledge_DocumentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Group_Knowledge_DocumentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wissen & Dokumente")
	return /** @type {LocalizedString} */ ("Knowledge & documents")
});